import { Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import { countryList } from '../../Context/api';
import axios from 'axios';
import { commonMessage, statusCodes } from '../../Constants/generalConfig';
const Revenue = () => {
    const [countryData, setCountryData] = useState([])
    const [filter, setFilter] = useState({
        provider: '',
        day: '',
        country: '',
        statDate: '',
        endDate: '',
    })
    const adminData = JSON.parse(localStorage.getItem('adminData'));

    useEffect(() => {
        countryListData()
    }, [])
    const countryListData = () => {
        const data = {
            id: adminData.userId,
            isDeleted: true,
            isActive: true,
            searchText: '',
            page: 1,
            count: 100
        }

        axios.post(countryList(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setCountryData(resp.data.data)
            }

            else {
                setCountryData([])
            }
        })
    }
    const handleChange = (e) => {
        const { name, value } = e.target
        setFilter((pre) => ({
            ...pre,
            [name]: value
        }))
    }
    return (
        <>
            <section>
                <div className="m-t-3 cus-padd cusheight">
                    <header>
                        <h2 className='page-tittle'>
                            Revenue
                        </h2>
                        <hr />
                    </header>

                    <div style={{ height: '20px' }}>
                        <Button size='small' variant="outlined" startIcon={<LocalPrintshopIcon />}>
                            Print
                        </Button>
                        <Button size='small' className='ms-2' variant="outlined" startIcon={<FileOpenIcon />}>
                            Export
                        </Button>
                    </div>
                    <div className='d-flex justify-content-end' >

                        <div className='d-flex'>
                            <div className='me-2'>
                                {/* <input style={{ justifyContent: 'start', marginTop: '25px', paddingBottom: '5px' }} className='search me-2 form-control' type="text" name="provider"
                                placeholder='Search by provider' value={filter.provider} onChange={(e) => handleChange(e)} /> */}
                                <select className='form-select' style={{ justifyContent: 'start', marginTop: '25px', paddingBottom: '5px' }} name="provider"
                                    placeholder='Search by provider' value={filter.provider} onChange={(e) => handleChange(e)}>
                                    <option hidden>Select provider</option>
                                    <option value="A">A</option>
                                    <option value="B">B</option>
                                    <option value="C">C</option>
                                </select>

                            </div>
                            <div className='mt-4  d-flex me-2'>
                                <h6 className='mt-2'>Start</h6>
                                <h6 className='ms-1 mt-2'>Date</h6>
                                <input className='form-control ms-1' type="date" name="statDate" onChange={(e) => handleChange(e)} value={filter.statDate} style={{ height: '37px' }} />

                            </div>
                            <div className='mt-4 d-flex me-2'>
                                <h6 className='mt-2'>End</h6>
                                <h6 className='ms-1 mt-2'>Date</h6>
                                <input className='form-control ms-1' type="date" name="endDate" onChange={(e) => handleChange(e)} value={filter.endDate} style={{ height: '37px' }} />
                            </div>
                            <div className='me-2'>
                                <label className="form-label"></label>
                                <select className='form-select me-2' name='day'
                                    value={filter.day} onChange={(e) => { handleChange(e) }}
                                >
                                    <option hidden>Select</option>
                                    <option value='MONTHLY'>Mothly</option>
                                    <option value='YEARLY'>Yearly</option>
                                </select>
                            </div>
                            <div className='me-2'>
                                <label className="form-label"></label>
                                <select className='form-select me-2' name='country' value={filter.country} onChange={(e) => { handleChange(e) }} >
                                    <option hidden>Select country</option>
                                    {
                                        countryData?.map((item, index) =>
                                            <option value={item._id} key={index}>{item.name}</option>
                                        )
                                    }
                                </select>
                            </div>
                            <div class="dropdown d-flex align-items-center">
                                <button className="btn btn-primary  float-end px-3 my-4 ">Search</button>
                                <button className="btn btn-dark   px-4 my-4 ms-2" onClick={() => window.location.reload()}>Reset</button>
                            </div>
                        </div>
                    </div>

                    <div className='row d-flex justify-content-center mb-5 mt-4'>
                        <div className='col-sm-3 revenue_card text-center'>
                            <h4 className='pt-3 fw-bold'>$1000</h4>
                            <p>Revenue - 01.01.2024 - 01.05.2024 </p>
                        </div>
                        <div className='col-sm-3 revenue_card text-center'>
                            <h4 className='pt-3 fw-bold'>$1000</h4>
                            <p>Margin - 01.01.2024 - 01.05.2024 </p>
                        </div>
                    </div>

                    <table className="table  shadow mt-3">
                        <thead className="table-dark">
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Provider</th>
                                <th scope="col">Billing Frequency</th>
                                <th scope="col">Payment Mode</th>
                                <th scope="col">Start Date</th>
                                <th scope="col">End Date</th>
                                <th scope="col">Add Ons</th>
                                <th scope="col">Plan Price</th>
                            </tr>
                        </thead>
                        {/* <tbody>
              {
                serviceProviderData?.data?.length === undefined ? <div className='position-absolute top-10 end-50 mt-5 me-5'><h3>No record found</h3></div>
                  :
                  <>
                    {
                      serviceProviderData.data?.map((item, index) => {
                        return <>
                          <tr key={index}>
                            <th style={{ padding: '0.4rem .5rem' }} scope="row">{PER_PAGE * (page - 1) + index + 1}</th>
                            <td style={{ padding: '0.4rem .5rem' }}>{item.name}</td>
                            <td style={{ padding: '0.4rem .5rem' }}>{item.email}</td>
                            <td style={{ padding: '0.4rem .5rem' }}>{item.mobileNo}</td>
                            <td style={{ padding: '0.4rem .5rem' }}>{item.isAccepted === 'incomplete_profile' ? 'Profile Incomplete' : item.isAccepted?.charAt(0).toUpperCase() + item.isAccepted?.slice(1)}</td>
                            <td style={{ padding: '0.4rem .5rem' }}>
                              <div className="form-check form-switch" style={{ marginLeft: '44%' }}>
                                <input className="form-check-input" role='switch' type="checkbox" checked={item.isAssignLoginForProvider} onChange={() => statusChange(item)} />
                              </div>
                            </td>
                            <td style={{ padding: '0.4rem .5rem' }}>
                              {
                                item.isDeleted === true ? null
                                  :
                                  <>
                                    <Button variant="text" sx={{ color: 'black', fontSize: '12px' }} id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                                      <i className="fa-solid fa-ellipsis-vertical cursor"></i>
                                    </Button>
                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                      <a className="dropdown-item cursor" data-bs-toggle="modal" data-bs-target="#active" onClick={() => navigate(`assign-plan/${item._id}`)} >Assign Plan</a>
                                      <a className="dropdown-item cursor" data-bs-toggle="modal" data-bs-target="#active" onClick={() => navigate(`editProvider/${item._id}`)}>Edit</a>
                                      <a className="dropdown-item cursor" data-bs-toggle="modal" data-bs-target="#invitationResend" onClick={() => setServiceProvideId(item?._id)}>Re-send invitation </a>
                                      <a className="dropdown-item cursor" onClick={() => navigate(`plan-history/${item._id}`)}>Plan History</a>
                                    </ul>
                                  </>
                              }

                            </td>
                          </tr>
                        </>
                      })
                    }
                  </>
              }
            </tbody> */}
                    </table>
                    {/* <div className='w-100 d-flex justify-content-center mt-5 pb-3'>
            {serviceProviderData?.length === 0 ? null : count > 10 && <Pagination setpage={setPage} count={Math.ceil(count / PER_PAGE)} page={page} />
            }
          </div> */}
                </div>
            </section>
        </>
    )
}

export default Revenue